import { LogLevel, PublicClientApplication, RedirectRequest } from "@azure/msal-browser";
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "", // This is the ONLY mandatory field that you need to supply.
        authority: `https://textileexchangeexternal.ciamlogin.com/textileexchangeexternal.onmicrosoft.com`,
        knownAuthorities: ["textileexchangeexternal.ciamlogin.com"],
        redirectUri: window.location.origin, // defaults to window.location.origin
        postLogoutRedirectUri: window.location.origin, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ['openid profile offline_access'],
};
// const msalInstance = new PublicClientApplication(msalConfig);
// export default msalInstance;
// export const protectedResources = {
//     graphMe: {
//         endpoint: "https://graph.microsoft.com/v1.0/me",
//         scopes: ["User.Read"],
//     },
// }
